import { adminApi } from './Admin/AdminService';
import { alertApi } from './Alert/AlertService';
import { authServiceApi } from './Auth/AuthService';
import { brokerApi } from './Broker/BrokerService';
import { buyerApi } from './Buyer/BuyerService';
import { buyerEnquiryApi } from './BuyerEnquiry/BuyerEnquiryService';
import { lawyerApi } from './Lawyer/LawyerService';
import { legalRequestApi } from './LegalRequest/LegalRequestService';
import { negotiationApi } from './Negotiation/NegotiationService';
import { notificationApi } from './Notifications/NotificationsService';
import { ownershipApi } from './Ownership/OwnershipService';
import { paymentApi } from './Payment/PaymentService';
import { postalServiceApi } from './Postal/PostalService';
import { propertyApi } from './Property/PropertyService';
import { publicApi } from './Public/PublicService';
import { sellerApi } from './Seller/SellerService';

/**
 * The one list of `createApi` instances. `rootReducer`, `Store` and `handleLogout` all read
 * it, so adding a service is a single edit — a service registered in the reducer but missed
 * in the logout reset leaves the previous user's data in the cache.
 *
 * One instance per backend route prefix: not one per feature (too many reducers and
 * middlewares to keep in step) and not one for the whole API (every cache tag in one
 * namespace). The prefix is the natural seam because the backend is already organised by it.
 */
export const apiSlices = [
  authServiceApi,
  postalServiceApi,
  publicApi,
  propertyApi,
  sellerApi,
  buyerApi,
  alertApi,
  buyerEnquiryApi,
  negotiationApi,
  brokerApi,
  lawyerApi,
  ownershipApi,
  adminApi,
  paymentApi,
  legalRequestApi,
  notificationApi
] as const;
